import { render, staticRenderFns } from "./Bindofficialaccountdiatwo.vue?vue&type=template&id=569f9788&scoped=true"
import script from "./Bindofficialaccountdiatwo.vue?vue&type=script&lang=js"
export * from "./Bindofficialaccountdiatwo.vue?vue&type=script&lang=js"
import style0 from "./Bindofficialaccountdiatwo.vue?vue&type=style&index=0&id=569f9788&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "569f9788",
  null
  
)

export default component.exports